import React from 'react';
import ProgrammationRoot from 'containers/Programmations/Loadable';
import NewProgrammation from 'containers/Programmations/New/Loadable';
import { PageTrackerWrapper } from 'queries/user/track';
import Programmations from 'containers/Programmations/List/Loadable';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import ProgMatiereWrapper from 'containers/Programmations/ProgV2/ProgMatiereWrapperLoadable';
import ProgMatieresWrapper from 'containers/Programmations/ProgV2/ProgMatieresWrapperLoadable';
import { RedirectToFirstMatiere } from 'containers/Programmations/ProgV2/RedirectToFirstMatiere';
import { ProgWrapper } from 'containers/Programmations/ProgV2/ProgWrapper';
import { PreviewWrapper } from 'containers/Programmations/ProgV2/Preview';
import { ProgrammationOrProgression } from 'containers/Programmations/ProgV2/New/ProgrammationOrProgression';
import { NewProgrammation as NewProgrammationV2 } from './ProgV2/New/NewProgrammation';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import SchoolyearRedirect from 'components/Redirect/SchoolyearRedirect';
import { useProgrammationItemHierarchy } from 'containers/Programmations/atoms/useProgrammationItemHierarchy';
import { Spinner } from 'components/Spinner';

function RedirectToProgrammation() {
  const { pathname, search } = useLocation();
  const newPath = pathname.replace(/\/v2/, '');
  return <Navigate to={{ pathname: newPath, search }} replace />;
}

function GetItemAndRedirectToProgrammation() {
  const { itemId } = useParams<{ itemId: string }>();
  const { isLoading, data } = useProgrammationItemHierarchy({
    itemId: itemId || '',
  });
  if (isLoading) {
    return <Spinner />;
  }
  if (!data) {
    return <Navigate to="/programmations" />;
  }

  return (
    <SchoolyearRedirect
      to={`programmations/${data.programmationId}/matieres/${data.matiereId}?itemId=${itemId}`}
    />
  );
}

export const ProgrammationRoutes = {
  path: 'programmations',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.programmations" />
      <ProgrammationRoot />
    </>
  ),
  children: [
    {
      path: 'item-redirect/:itemId',
      element: <GetItemAndRedirectToProgrammation />,
    },
    {
      path: 'new',
      element: <NewProgrammation />,
      children: [
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Programmations - onboarding - progression ou programmation">
              <ProgrammationOrProgression />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'programmation',
          element: (
            <PageTrackerWrapper title="Programmations - onboarding - programmation config">
              <NewProgrammationV2 isProgression={false} />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'progression',
          element: (
            <PageTrackerWrapper title="Programmations - onboarding - progression config">
              <NewProgrammationV2 isProgression />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="Programmations - liste">
          <Programmations />
        </PageTrackerWrapper>
      ),
    },
    {
      path: ':programmationId/v2',
      children: [
        {
          index: true,
          element: <RedirectToProgrammation />,
        },
        {
          path: '*',
          element: <RedirectToProgrammation />,
        },
      ],
      element: <Outlet />,
    },
    {
      path: ':programmationId',
      element: <ProgWrapper />,
      children: [
        {
          index: true,
          element: <RedirectToFirstMatiere />,
        },

        {
          path: 'matieres',
          children: [
            {
              index: true,
              element: (
                <PageTrackerWrapper title="Programmation - edit matières">
                  <ProgMatieresWrapper />
                </PageTrackerWrapper>
              ),
            },
            {
              path: 'preview',
              element: (
                <PageTrackerWrapper title="Programmation - preview matières">
                  <PreviewWrapper />
                </PageTrackerWrapper>
              ),
            },
            {
              path: ':matiereId/preview',
              element: (
                <PageTrackerWrapper title="Programmation - preview matière">
                  <PreviewWrapper />
                </PageTrackerWrapper>
              ),
            },
            {
              path: ':matiereId',
              element: (
                <PageTrackerWrapper title="Programmation - edit matière">
                  <ProgMatiereWrapper />
                </PageTrackerWrapper>
              ),
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <SchoolyearRedirect to="programmations" />,
    },
  ],
};
